// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"defs","attrs":{},"children":[{"tag":"mask","attrs":{"id":"props.overlapMaskId_fill2","maskUnits":"userSpaceOnUse","maskContentUnits":"userSpaceOnUse","mask-type":"luminance","x":"0","y":"0","width":"24","height":"24"},"children":[{"tag":"rect","attrs":{"x":"0","y":"0","width":"24","height":"24","fill":"#fff"}},{"tag":"circle","attrs":{"cx":12,"cy":12,"r":3,"stroke":"#000","strokeWidth":"props.strokeWidth","fill":"none"}}]}]},{"tag":"g","attrs":{"id":"center-focus-strong"},"children":[{"tag":"circle","attrs":{"id":"fill2","cx":12,"cy":12,"r":3,"fill":"props.fillColor2","mask":"props.overlapMaskUrl_fill2"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8 3H3V8M16 3H21V8M8 21H3V16M16 21H21V16","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"circle","attrs":{"id":"stroke2","cx":12,"cy":12,"r":3,"stroke":"props.strokeColor2","strokeWidth":"props.strokeWidth"}}]}]};

const CenterFocusStrongIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'center-focus-strong',
    ref,
    icon: element,
  },
));

CenterFocusStrongIcon.displayName = 'CenterFocusStrongIcon';

export default CenterFocusStrongIcon;
